
import { CLEAR_LOCATION_REQUEST, GET_LOCATION_ERROR, GET_LOCATION_REQUEST, GET_LOCATION_SUCCESS } from "../actions/action-type";


const initalState = {
    locationResponse: [],
    islocationError: false,
    islocationSuccess: false,
    islocationLoading: false
};

const locationReducer = (state = initalState, { type, locationResponse }) => {
    switch (type) {
        case GET_LOCATION_REQUEST:
            return {
                ...state,
                islocationLoading: true,
                islocationError: false,
                islocationSuccess: false
            };
        case GET_LOCATION_SUCCESS:
            return {
                ...state,
                locationResponse: locationResponse,
                islocationLoading: false,
                islocationError: false,
                islocationSuccess: true,
            };
        case GET_LOCATION_ERROR:
            return {
                ...state,
                islocationLoading: false,
                islocationError: true,
                islocationSuccess: false
            };
        case CLEAR_LOCATION_REQUEST : return initalState
        default:
            return state;
    }
};

export default locationReducer;